export default __webpack_public_path__ + "static/media/home.929803ef.svg";